import {Component, OnInit} from '@angular/core';
import {ImSchemaBaseComponent} from "../im-schema-base.component";


@Component({
    selector: 'im-schema-full',
    templateUrl: 'im-schema-full.component.html',
    standalone: false
})
export class ImSchemaFullComponent extends ImSchemaBaseComponent implements OnInit {

    ngOnInit(): void {
        super.ngOnInit();
    }

}
